import {
  ABTestPublishedStatus,
  AutomationStatus,
  CommunicationPublishedStatus,
} from "../config/enums";
import { badgeClassName } from "../elements/badgeClassName";

interface CellProps {
  value?: unknown;
  row?: Record<string, unknown>;
}

// Green for Published, yellow for Testing, else the info background with body text.
function statusBadge(labels: Record<string, number>) {
  return function StatusBadgeCell({ value }: CellProps) {
    const label = Object.keys(labels).find(
      (key) => labels[key] === Number(value)
    );

    if (value === null || value === undefined || value === "" || !label) {
      return null;
    }

    if (label !== "Published" && label !== "Testing") {
      return <span className="badge bg-info text-body">{label}</span>;
    }

    const variant = label === "Published" ? "success" : "warning";

    return <span className={badgeClassName(variant)}>{label}</span>;
  };
}

const text = (value: unknown) => String(value ?? "");

const isBlank = (value: unknown) =>
  value === null || value === undefined || value === "";

function AutomationCount({ value }: CellProps) {
  const count = Number(value);

  if (isBlank(value) || !Number.isFinite(count)) {
    return <>{text(value)}</>;
  }

  return <>{count.toLocaleString("en-GB", { maximumFractionDigits: 0 })}</>;
}

// A rate arrives as a fraction or as a percentage already.
function AutomationRate({ value }: CellProps) {
  const rate = Number(value);

  if (isBlank(value) || !Number.isFinite(rate)) {
    return <>{text(value)}</>;
  }

  const percentage = rate > 0 && rate <= 1 ? rate * 100 : rate;

  return <>{Number.isInteger(percentage) ? percentage : Number(percentage.toFixed(1))}%</>;
}

export const listFieldComponents = {
  abTestStatus: statusBadge(ABTestPublishedStatus),
  automationStatus: statusBadge(AutomationStatus),
  communicationStatus: statusBadge(CommunicationPublishedStatus),
  automationCount: AutomationCount,
  automationRate: AutomationRate,
};
